require('/opt/odin/app/frontend/pages/discipline/components/summary/index.module.scss');module.exports = "../../app/cells/pages/discipline/summary/show.erb";